import axiosRoom from "../utils/axios.wrapper";
 
export const getRooms = async () => {
  const { data } = await axiosRoom.get("/room");
  return data.items || data;
};
 
export const getActiveRooms = async () => {
  const { data } = await axiosRoom.get("/room/active");
  return data.items || data;
};
 
export const getRoomById = async (id) => {
  const { data } = await axiosRoom.get(`/room/${id}`);
  return data;
};
 
export const getRoomsByZone = async (zoneId) => {
  const { data } = await axiosRoom.get(`/room/zone/${zoneId}`);
  return data.items || data;
};
 
export const createRoom = async (room) => {
  const { data } = await axiosRoom.post("/room/create", room);
  return data;
};
 
export const updateRoom = async (id, room) => {
  const { data } = await axiosRoom.put(`/room/${id}`, room);
  return data;
};
 
export const softDeleteRoom = async (id) => {
  const { data } = await axiosRoom.patch(`/room/${id}/soft-delete`);
  return data;
};
 
export const hardDeleteRoom = async (id) => {
  const { data } = await axiosRoom.delete(`/room/${id}`);
  return data;
};
 
// --- Waiter assignment ---
export const getRoomWaiters = async (roomId) => {
  const { data } = await axiosRoom.get(`/room/${roomId}/waiters`);
  return data.items || data;
};
 
export const assignWaiterToRoom = async (roomId, userId) => {
  const { data } = await axiosRoom.post(`/room/${roomId}/waiters/${userId}`);
  return data;
};
 
export const removeWaiterFromRoom = async (roomId, userId) => {
  const { data } = await axiosRoom.delete(`/room/${roomId}/waiters/${userId}`);
  return data;
};
 
export const roomService = {
  getRooms,
  getActiveRooms,
  getRoomById,
  getRoomsByZone,
  createRoom,
  updateRoom,
  softDeleteRoom,
  hardDeleteRoom,
  getRoomWaiters,
  assignWaiterToRoom,
  removeWaiterFromRoom,
};
 